import { Attributes } from '~/components/Product/types/product';
import { useBFF } from '~/composables/useBFF/useBFF';
import type { RecoResponse } from '~/services/bff/api.recommend.service';

export const useRecoSlider = (recommenderType: string, productId: string) => {
  const { $recommend } = useBFF();

  const loading = ref(true);
  const products = useState<RecoResponse>(`useRecoSlider-products-${recommenderType}-${productId}`, () => shallowRef([]));

  const fetchRecommendations = async (type: 'home' | 'pdp', productId: string | null | undefined, category: string | null | undefined = null) => {
    loading.value = true;

    const cookie = useCookie<string | undefined>('_lb');

    try {
      const { data } = await $recommend.getRecommendations({
        attributeFilterNames: [
          Attributes.COLOR_CODE,
          Attributes.DETAIL_NAME,
          Attributes.COLOR,
          Attributes.SIZE,
          Attributes.SIZE_ORDER,
          Attributes.DISCOUNT_SALE_VALUE,
        ],
        withVariants: true,
        ...(category ? { categories: [category] } : null),
      }, {
        userId: cookie.value,
        type,
        productId,
      });

      products.value = data ?? {};
    }
    finally {
      loading.value = false;
    }
  };

  return {
    loading: computed(() => loading.value),
    products: computed(() => products.value),

    fetchRecommendations,
  };
};
